import React from 'react'
import Helmet from 'react-helmet'
import { config } from 'config'
import _ from 'lodash'
import { Container, Grid, Breakpoint, Span } from 'react-responsive-grid'
import { rhythm } from 'utils/typography'
import PortfolioHead from 'components/PortfolioHead'
import PortfolioIntroBanner from 'components/PortfolioIntroBanner'
import PortfolioNextPrevLink from 'components/PortfolioNextPrevLink'
import works from 'data/works'
import { findWork } from 'data/works-helper'
import Gallery from 'components/Gallery'

export default class ReactComponent extends React.Component {

  prefixPath(fileName) {
    return this.props.route.page.path + fileName;
  }

  render () {
    this.galleries = [
      [
        {src: this.prefixPath('landing.jpg'), caption: 'Landing Page'},
        {src: this.prefixPath('mockup-02.jpg'), caption: 'Modules directory'},
        {src: this.prefixPath('mockup-03.jpg'), caption: 'Module details'},
        {src: this.prefixPath('mockup-04.jpg'), caption: 'Modules directory (mobile)'},
        {src: this.prefixPath('mockup-05.jpg'), caption: 'Modules directory (mobile)'},
        {src: this.prefixPath('mockup-06.jpg'), caption: 'Modules detail (mobile)'}
      ]
    ];

    this.galleries[0] = this.galleries[0].map((v, i) => {
      v.index = i;
      return v;
    });

    const data = findWork(works, this.props.route.page.path);
    return (
      <div>
        <Helmet
          title={`${config.siteTitle} | ${data.name}`} 
        />
        <PortfolioHead data={data} />
        <Container
            style={{
              maxWidth: 960,
              paddingTop: 0,
              padding: `${rhythm(1)} ${rhythm(3/4)}`,
            }}
          >

          <div className="section">
            <div className="section-header">
              <PortfolioNextPrevLink data={data} />
              <h2>Branding Kit</h2>
            </div>
            <p>
              For my own company Runnables, I designed the corporate branding kit which includes the logo, business cards, the website and a wireframe worksheet. 
            </p>
            <br />
            <img src={this.prefixPath('runnables-branding-kit-iso.jpg')} />
            <br/>
            <img src={this.prefixPath('runnables-business-card.jpg')} />

            <br /><br />
            <p>
              Our business card can come in handy as a wireframe sketching sheet.
            </p>
            <img src={this.prefixPath('namecard-usage.jpg')} />

            <p>
              For serious wireframing, there is an A5-sized sheets with a mobile screen at 1:1 scale.
            </p>
          </div>


          <div className="section">
            <div className="section-header">
              <h2>Contributors</h2>
            </div>
            <ul>
              <li>Soravis Prakkamakul (Designer)</li>
              <li>Kanit Srisuthep (Web Developer)</li>
            </ul>
          </div>
          <div className="section">
            <PortfolioNextPrevLink data={data} />
          </div>
        </Container>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./works/runnables-branding-kit/index.jsx
 **/